import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Receipt from "../Accountings/Receipt";
import GridConfig from "../GridConfig";

export default class PayExpenses extends Base {
    constructor(props) {
        super(props);
        this.state = {
            buildingId: props.BuildingId,
            caller: props.Caller,
            controllerName: 'receipt',
            IsV2: true,
            data: null,
            loading: true,
            configName: 'payexpense_grid',
            moduleName: 'دریافتها و پرداختی ها'
        };
        this.state.filters = {
            buildingId: this.state.buildingId
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    async refreshData(e, action = "list") {
        if (!this.isNull(e)) e.preventDefault();
        this.setState({ loading: true });

        this.httpPost("api/v1/payexpense/" + action, {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 0) {
                this.setState({
                    selectedIds: [],
                    loading: false
                });
            }
            else {
                this.setState({
                    data: data,
                    loading: false
                })
            }
        })
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Receipt Source={2} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Receipt Source={2} BuildingId={this.state.buildingId} Type={1} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "description", caption: "موضوع صورتحساب", show: true },
                { field: "typeString", caption: "دریافت/پرداخت", show: true },
                { field: "total", caption: "مبلغ", show: true },
                { field: "dateString", caption: "تاریخ", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'description' && f.show) t.push({ field: f.field, flex: 3, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.description}</a> } });
            if (f.field == 'typeString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'buildingTitle' && f.show) t.push({ field: f.field, flex: 2, headerName: f.caption });
            if (f.field == 'total' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.total) } });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: "id", headerName: "عملیات", cellRenderer: (props) => {
                return <a className="hand" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                    <em className="icon ni ni-cross-fill-c"></em> حذف
                </a>
            }
        });
        
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">دریافتها و پرداختها</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, print: false, pdf: false, excell: false, remove: false, config: false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}